module.exports = __webpack_public_path__ + "img/maTouQin3.c0d02609.png";